
export const existingBilanQueryKey = (siren: string, dateClotureBilan: string, typeBilan: string) =>
    ['company', 'bilan', siren, dateClotureBilan, typeBilan];
